<template
  ><v-dialog v-model="value" persistent max-width="50rem">
    <v-card>
      <v-toolbar color="primary darken-1" dark dense>
        {{ this.isEdit ? $t("portfolio.Goals.edit") : $t("portfolio.Goals.add") }}
        <v-spacer></v-spacer>

        <v-btn icon dark @click="value = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-form ref="goalForm" v-model="formValid">
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" class="pa-0">
                <v-text-field
                  dense
                  v-model="goal.title"
                  :label="$t('portfolio.Goals.titleOfGoal')"
                  outlined
                  :rules="[
                    value => value.length >= 3 || $t('portfolio.Goals.validation.titleMinLength'),
                    value => !!value || $t('portfolio.Goals.validation.titleRequired'),
                    value => value.length < 450 || $t('portfolio.Goals.validation.titleMaxLength')
                  ]"
                ></v-text-field>
              </v-col>

              <v-col cols="12" class="pa-0">
                <v-textarea
                  dense
                  rows="3"
                  v-model="goal.description"
                  :label="$t('portfolio.Goals.description')"
                  outlined
                ></v-textarea>
              </v-col>

              <v-col cols="12" class="pa-0">
                <v-menu
                  v-model="menu"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      dense
                      v-model="goal.dueDate"
                      :label="$t('portfolio.Goals.dueDate')"
                      :placeholder="$t('portfolio.Goals.dueDate')"
                      readonly
                      outlined
                      :rules="[value => !!value || $t('portfolio.Goals.validation.required')]"
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="goal.dueDate" @input="menu = false"></v-date-picker>
                </v-menu>
              </v-col>

              <v-col cols="12" class="pa-0">
                <v-select
                  dense
                  v-model="goal.progressStatus"
                  :items="progressStatuses"
                  :label="$t('portfolio.Goals.ProgressStatus.title')"
                  :item-text="x => $t(x.text)"
                  outlined
                  hide-details
                ></v-select>
              </v-col>

              <v-col cols="12" class="pa-0 py-4">
                <v-icon
                  class="me-2"
                  @click="goal.visible = !goal.visible"
                  :color="goal.visible ? 'success' : 'grey'"
                >
                  {{ goal.visible ? "mdi-eye" : "mdi-eye-off" }}
                </v-icon>
                <v-label>{{ $t("forum.visible") }}</v-label>
              </v-col>
                <v-col cols="12" class="pa-0">
                <custom-file-uploader
                  v-if="value"
                  ref="uploader"
                  @file-uploaded="onUploaded"
                  locationName="Portfolio"
                ></custom-file-uploader>
              </v-col>
            </v-row>
        
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-btn color="primary" :disabled="!formValid" @click="submitGoal">{{ $t("save") }}</v-btn>
          <v-btn color="red" text @click="value = false">{{ $t("cancel") }}</v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog></template
>

<script>
import customFileUploader from "../../custom-file-uploader.vue";
export default {
  name: "GoalsDialog",
  components: {
    customFileUploader
  },
  data() {
    return {
      isEdit: false,
      formValid: false,
      value: false,
      menu: false,
      progressStatuses: [
        { text: "portfolio.Goals.ProgressStatus.toDo", value: 0 },
        { text: "portfolio.Goals.ProgressStatus.inProgress", value: 1 },
        { text: "portfolio.Goals.ProgressStatus.achieved", value: 2 },
        { text: "portfolio.Goals.ProgressStatus.later", value: 3 },
        { text: "portfolio.Goals.ProgressStatus.cancelled", value: 4 }
      ],
      goal: {
        title: "",
        description: "",
        dueDate: null,
        progressStatus: 0,
        visible: true,
        files: []
      }
    };
  },

  methods: {
    submitGoal() {
      this.$refs.goalForm.validate();
      if (!this.formValid) {
        return;
      }
      if (this.isEdit) {
        this.axios
          .post("/Goal/Update", this.goal)
          .then(() => {
            this.$emit("success");
          })
          .catch(error => {
            console.error("Error updating goal:", error);
          });
      } else {
        this.axios
          .post("/Goal/Create", this.goal)
          .then(() => {
            this.$emit("success");
          })
          .catch(error => {
            console.error("Error adding goal:", error);
          });
      }
      this.value = false;
    },
    clear() {
      this.goal = {
        title: "",
        description: "",
        dueDate: null,
        progressStatus: 0,
        visible: true,
        files: []
      };
    },
    showDialog(status) {
      this.clear();
      this.isEdit = false;
      this.value = true;
      if (status) {
        this.goal.progressStatus = status;
      }
      this.$refs.goalForm.resetValidation();
    },
    showEditDialog(goal) {
      this.clear();
      this.isEdit = true;
      this.goal = goal;
      this.goal.dueDate = this.$moment(goal.dueDate).format("YYYY-MM-DD");
      this.value = true;
    },
    onUploaded(e) {
      const fileRes = JSON.parse(e.request.responseText).data;
      this.goal.files.push({ fileUrl: fileRes.fileUrl });
    }
  }
};
</script>
